import { classNames } from '../utilities';

export const CalendarRangeIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames('cursor-pointer', className)}
      onClick={onClick}
      fill="none"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.33333H17M4.55556 1V2.77778M13.4444 1V2.77778M3.66667 9H5.44444M8.11111 9H9.88889M12.5556 9H14.3333M3.66667 11.6667H5.44444M8.11111 11.6667H9.88889M12.5556 11.6667H14.3333M3.66667 14.3333H5.44444M8.11111 14.3333H9.88889M12.5556 14.3333H14.3333M3.84444 17H14.1556C15.1512 17 15.6491 17 16.0293 16.8062C16.3638 16.6358 16.6358 16.3638 16.8062 16.0293C17 15.6491 17 15.1512 17 14.1556V5.62222C17 4.62657 17 4.12875 16.8062 3.74846C16.6358 3.41395 16.3638 3.14198 16.0293 2.97155C15.6491 2.77778 15.1512 2.77778 14.1556 2.77778H3.84444C2.8488 2.77778 2.35097 2.77778 1.97068 2.97155C1.63617 3.14198 1.3642 3.41395 1.19377 3.74846C1 4.12875 1 4.62657 1 5.62222V14.1556C1 15.1512 1 15.6491 1.19377 16.0293C1.3642 16.3638 1.63617 16.6358 1.97068 16.8062C2.35097 17 2.84879 17 3.84444 17Z"
        stroke="#575757"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
};
